import React from 'react';
import PropTypes from 'prop-types';
import { labelTextReplace } from '../../helpers';
import AutoCompleteTeam from './AutoCompleteTeam';
import TextField from 'material-ui/TextField';
import InputMaterial from '../../../../../front-v2/components/uiElements/forms/InputMaterial';

const TeamPicker = ({
    id,
    params: { defaultName = '', type, propsMap: { stats: statsMap, ...propsMap } = {}, ...params } = {},
    fullWidth = true,
    updateWidgetJSPropField,
    isCustomInput = true,
}) => {
    if (id == null || type !== 'team') {
        return null;
    }

    const InputComponent = isCustomInput ? InputMaterial : TextField;

    return (
        <div>
            <AutoCompleteTeam
                id={id}
                defaultName={defaultName}
                propsMap={propsMap}
                updateWidgetJSPropField={updateWidgetJSPropField}
            />
            {Object.entries({ ...propsMap, ...(statsMap || {}) }).map(([key = '']) => (
                <InputComponent
                    key={key}
                    floatingLabelText={labelTextReplace(key)}
                    value={params[key] == null ? '' : params[key]}
                    fullWidth={fullWidth}
                    onChange={(event, value) => {
                        updateWidgetJSPropField(id, { [key]: value });
                    }}
                />
            ))}
        </div>
    );
};

TeamPicker.propTypes = {
    id: PropTypes.string,
    params: PropTypes.shape({
        name: PropTypes.string,
        score: PropTypes.string,
        placeholder: PropTypes.string,
    }),
    propsMap: PropTypes.objectOf(PropTypes.string),
    fullWidth: PropTypes.bool,
    isCustomInput: PropTypes.bool,
    updateWidgetJSPropField: PropTypes.func.isRequired,
};

export default TeamPicker;



/** WEBPACK FOOTER **
 ** ../src/dash/front/editor/pickers/components/TeamPicker/index.js
 **/